import render from 'preact-render-to-string';
import { Link } from 'preact-router';
import { useEffect } from 'preact/hooks';
import Table from "../components/ui/Table";
import useTable from '../context/TableContext';

export default function LocationsList() {
    const { tableData, tableDataDisplay, handleDisplaying } = useTable();
    const columns = [
        { label: "Commune", accessor: "city", sortable: true },
        { label: "Nom", accessor: "name", sortable: true },
        { label: "Nb animaux", accessor: "nb_animals", sortable: false },
        { label: "Date inter", accessor: "nextInterventionDateApi", sortable: true },
    ];

    useEffect(() => {
        handleDisplaying('locations');
    }, [tableData]);

    function cellFormat(value, accessor, data) {
        let str = value;
        switch (accessor) {
            case 'city':
                str = render(<Link href={'/location/' + data.id}>{data.city}</Link>);
                break;

            case 'name':
                str = render(<Link href={'/location/' + data.id}>{data.name}</Link>);
                break;
                
            case 'nb_animals':
                str = tableData.animals.filter((a) => a.location && (a.location.id == data.id)).length;
                break;

            case 'nextInterventionDateApi':
                if (value && value != '——') {
                    str = new Date(value).toLocaleDateString();
                }
                break;

            default:
                break;
        }
        return str;
    }

    if (typeof tableDataDisplay.locations == 'undefined' || tableDataDisplay === null) {
        return <div className="text-center pt-5">Loading locations ...</div>;
    }

    return (
        <Table id="locations" caption="Liste des terrains" columns={columns} selectable={false} cellFormat={cellFormat} pagination={true} />
    );
}